/**
 * Script para duplicar la primera miniatura cuando hay menos del mínimo configurado en móvil
 */
(function() {
  // Obtener configuración desde el section settings
  function getSettings() {
    const sectionElement = document.querySelector('[data-product-featured]');
    if (sectionElement) {
      const productData = JSON.parse(sectionElement.getAttribute('data-product-featured'));
      const sectionId = productData.sectionId;
      
      // Buscar el section específico para obtener la configuración
      const section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (section) {
        return {
          enabled: section.dataset.enableDuplicateThumbsMobile !== 'false',
          minThumbs: parseInt(section.dataset.minThumbsMobile) || 5,
          enableConsoleLog: section.dataset.enableConsoleLog === 'true'
        };
      }
    }
    
    // Valores por defecto si no se encuentra la configuración
    return {
      enabled: true,
      minThumbs: 5,
      enableConsoleLog: false
    };
  }

  // Función para limpiar miniaturas duplicadas
  function cleanDuplicatedThumbnails() {
    const thumbContainers = document.querySelectorAll('.t4s-carousel__nav, .t4s-row.t4s-carousel__nav');
    
    thumbContainers.forEach(function(container) {
      // Eliminar todas las miniaturas duplicadas
      const duplicatedThumbs = container.querySelectorAll('.t4s-duplicated-thumb');
      duplicatedThumbs.forEach(function(thumb) {
        thumb.remove();
      });
      
      // Solo limpiar estilos aplicados específicamente por nuestro script
      const thumbItems = container.querySelectorAll('.t4s-product__thumb-item:not(.t4s-duplicated-thumb), .t4s-col-item:not(.t4s-duplicated-thumb)');
      thumbItems.forEach(function(item) {
        // Calcular el porcentaje basado en la configuración actual
        const settings = getSettings();
        const widthPercentage = (100 / settings.minThumbs) + '%';
        const flexValue = `0 0 ${widthPercentage}`;
        
        // Solo remover los estilos específicos que aplicamos en móvil si coinciden exactamente
        if (item.style.maxWidth === widthPercentage) {
          item.style.removeProperty('max-width');
        }
        if (item.style.flex === flexValue) {
          item.style.removeProperty('flex');
        }
        if (item.style.minWidth === widthPercentage) {
          item.style.removeProperty('min-width');
        }
        if (item.style.width === widthPercentage) {
          item.style.removeProperty('width');
        }
      });
      
      // Resetear el flag de procesado para permitir nueva duplicación si es necesario
      delete container.dataset.thumbsProcessed;
    });
  }
  
  // Función principal para duplicar miniaturas
  function duplicateThumbnails() {
    const settings = getSettings();
    
    // Solo ejecutar si está habilitado y en dispositivos móviles
    if (!settings.enabled || window.innerWidth > 767) return;
    
    // Seleccionar todos los contenedores de miniaturas
    const thumbContainers = document.querySelectorAll('.t4s-carousel__nav, .t4s-row.t4s-carousel__nav');
    
    thumbContainers.forEach(function(container) {
      // Verificar si el contenedor ya ha sido procesado
      if (container.dataset.thumbsProcessed === 'true') return;
      
      // Seleccionar todas las miniaturas originales (no duplicadas)
      const originalThumbItems = container.querySelectorAll('.t4s-product__thumb-item:not(.t4s-duplicated-thumb), .t4s-col-item:not(.t4s-duplicated-thumb)');
      
      // Si hay menos miniaturas que el mínimo configurado
      if (originalThumbItems.length > 0 && originalThumbItems.length < settings.minThumbs) {
        // Cuántas miniaturas faltan para llegar al mínimo
        const missingThumbs = settings.minThumbs - originalThumbItems.length;
        
        if (settings.enableConsoleLog) {
          console.log(`Hang Ten Mexico: Encontradas ${originalThumbItems.length} miniaturas originales, clonando ${missingThumbs} más para llegar a ${settings.minThumbs}`);
        }
        
        // Clonar la primera miniatura tantas veces como sea necesario
        for (let i = 0; i < missingThumbs; i++) {
          const clonedThumb = originalThumbItems[0].cloneNode(true);
          clonedThumb.classList.add('t4s-duplicated-thumb');
          container.appendChild(clonedThumb);
        }
        
        // Marcar el contenedor como procesado
        container.dataset.thumbsProcessed = 'true';
        
        // Aplicar estilos para asegurarse de que se muestran el número correcto de miniaturas
        const widthPercentage = (100 / settings.minThumbs) + '%';
        const flexValue = `0 0 ${widthPercentage}`;
        
        container.querySelectorAll('.t4s-product__thumb-item, .t4s-col-item').forEach(function(item) {
          item.style.maxWidth = widthPercentage;
          item.style.flex = flexValue;
          item.style.minWidth = widthPercentage;
          item.style.width = widthPercentage;
        });
      }
    });
  }
  
  // Función para manejar cambios de tamaño de pantalla
  function handleResize() {
    if (window.innerWidth > 767) {
      // Desktop: limpiar miniaturas duplicadas
      cleanDuplicatedThumbnails();
    } else {
      // Mobile: duplicar miniaturas si es necesario
      setTimeout(duplicateThumbnails, 100);
    }
  }
  
  // Ejecutar cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', function() {
    // Ejecutar inicialmente
    setTimeout(handleResize, 500);
    
    // Ejecutar cada vez que se cambie el tamaño de la ventana
    window.addEventListener('resize', function() {
      // Usar debounce para evitar múltiples llamadas
      clearTimeout(window.resizeTimeout);
      window.resizeTimeout = setTimeout(handleResize, 150);
    });
    
    // Observar cambios en el DOM para detectar cuando se cargan las miniaturas dinámicamente
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Verificar si algún nodo añadido es o contiene un contenedor de miniaturas
          for (const node of mutation.addedNodes) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.classList && 
                  (node.classList.contains('t4s-carousel__nav') || 
                   node.classList.contains('t4s-product__thumb-item'))) {
                setTimeout(handleResize, 200);
                break;
              }
              
              // Verificar si contiene miniaturas
              const thumbContainers = node.querySelectorAll('.t4s-carousel__nav');
              if (thumbContainers.length > 0) {
                setTimeout(handleResize, 200);
                break;
              }
            }
          }
        }
      }
    });
    
    // Observar todo el cuerpo del documento
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
